import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { NewUsersModelRef, UsersStore } from '@src/views/users/domain/user.model';
import React from "react";
import {
  NewUsersModelRef,
  RoleMinimal,
  UsersStore,
} from "../domain/user.model";
import { ApplicationResponse } from "@src/common/domain/common.model";
import api from "@src/common/services/api.service";
import AppConstants from "@src/utils/app.constants";
import {buildUserFromToken, User} from "@auth/domain/auth.config";
import {jwtDecode} from "jwt-decode";
export const addUsersList = createAsyncThunk<void, any>(
  "users/addUsers",
  async (payload: any) => {
    const response = await api.post<ApplicationResponse<NewUsersModelRef[]>>(
      `${AppConstants.api}/user/create`,
      payload
    );
  }
);
export const userByDepartmentList = createAsyncThunk<any[], any>(
  "users/userByDepartmentList",

  async (id) => {
    const response = await api.get<ApplicationResponse<NewUsersModelRef[]>>(
      `${AppConstants.api}/user/listByDepartment?departmentId=` + id
    );
    return response.data.data || [];
  }
);
export const userByGroupList = createAsyncThunk<any[], any>(
  "users/userByGroupList",
  async (id) => {
    const response = await api.get<ApplicationResponse<NewUsersModelRef[]>>(
      `${AppConstants.api}/user/listByGroup?userGroupId=` + id
    );
    return response.data.data || [];
  }
);

export const updateUser = createAsyncThunk<any, { id: string; data: any }>(
  "users/updateUser",
  async ({ id, data }) => {
    try {
      const response = await api.put<ApplicationResponse<any>>(
        `${AppConstants.api}/user/update?id=${id}`,
        data
      );
      const token =  response.data.message;
      if(token!=null && token.length>0){
        const user: User = buildUserFromToken(jwtDecode(token));
        return {user,token};
      }
      return;
    } catch (error) {
      // return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const deleteUser = createAsyncThunk(
  "users/deleteUser",
  async (id: string) => {
    try {
      const response = await api.delete<ApplicationResponse<any[]>>(
        `${AppConstants.api}/user/delete?id=${id}`
      );
      return response.data.data || [];
    } catch (err) {
      return [];
    }
  }
);
export const fetchUsersList = createAsyncThunk<any[], void>(
  "users/fetchUsers",
  async () => {
    const response = await api.get<ApplicationResponse<NewUsersModelRef[]>>(
      `${AppConstants.api}/user/list`
    );
    return response.data.data || [];
  }
);

export const fetchRolesList = createAsyncThunk<RoleMinimal[], void>(
  "role/fetchRoles",
  async () => {
    const response = await api.get<ApplicationResponse<RoleMinimal[]>>(
      `${AppConstants.api}/role`
    );
    return response.data.data || [];
  }
);

const usersSlice = createSlice({
  name: "users",

  initialState: {
    minimal: { status: "loading", error: null, data: [] },
    roleminimal: { status: "loading", error: null, data: [] },
    userByDepartmentMinimal: { status: "loading", error: null, data: [] },
    userByGroupMinimal: { status: "loading", error: null, data: [] },
  } as UsersStore,

  reducers: {
    resetUsers: (state) => {
      state.minimal = {
        status: "idle",
        data: [],
        error: null,
      };
    },
    resetUsersByDepartment: (state) => {
      state.userByDepartmentMinimal = {
        status: "idle",
        data: [],
        error: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsersList.pending, (state, action) => {
        state.minimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchUsersList.fulfilled, (state, action) => {
        state.minimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchUsersList.rejected, (state, action) => {
        state.minimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      .addCase(userByGroupList.pending, (state, action) => {
        state.userByGroupMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(userByGroupList.fulfilled, (state, action) => {
        state.userByGroupMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(userByGroupList.rejected, (state, action) => {
        state.userByGroupMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      })
      .addCase(userByDepartmentList.pending, (state, action) => {
        state.userByDepartmentMinimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(userByDepartmentList.fulfilled, (state, action) => {
        state.userByDepartmentMinimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(userByDepartmentList.rejected, (state, action) => {
        state.userByDepartmentMinimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      });
    builder
      .addCase(fetchRolesList.pending, (state, action) => {
        state.roleminimal = {
          status: "loading",
          data: [],
          error: null,
        };
      })
      .addCase(fetchRolesList.fulfilled, (state, action) => {
        state.roleminimal = {
          status: "idle",
          data: action.payload,
          error: null,
        };
      })
      .addCase(fetchRolesList.rejected, (state, action) => {
        state.roleminimal = {
          status: "failed",
          data: [],
          error: action.error,
        };
      });
  },
});
export const { resetUsers, resetUsersByDepartment } = usersSlice.actions;

export default usersSlice.reducer;
